import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { requestLogout } from 'client/modules/Auth/AuthActions';
import prepareHeaders from 'client/util/prepareHeaders';
import navigationService from './navigationService';
import Config from '../../server/config';

const baseQuery = fetchBaseQuery({ baseUrl: Config.apiUrl, prepareHeaders });

const _isRequire2FASetupError = error => {
  // Check if this is a 2FA setup required error
  return (
    error?.status === 401 &&
    error?.data?.message ===
      'Two-factor authentication setup required before accessing this resource'
  );
};

const handle2FASetupRequired = () => {
  // Save current path so user can return after 2FA setup
  const currentPath =
    typeof window !== 'undefined' ? window.location.pathname + window.location.search : null;

  // Navigate to 2FA setup page with the current path in route state
  // This matches the pattern used in AuthActions.js for 2FA flows
  if (currentPath && currentPath !== '/2fa-setup') {
    navigationService.replace('/2fa-setup', { state: { nextPath: currentPath } });
  } else {
    navigationService.replace('/2fa-setup');
  }
};

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401 && !/^(public\/)?auth(\/|$)/.test(args.url)) {
    if (
      result.error.data?.message ===
      'Two-factor authentication setup required before accessing this resource'
    ) {
      handle2FASetupRequired();
    } else {
      api.dispatch(requestLogout());
    }
  }

  return result;
};

export default baseQueryWithReauth;
